import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DataManager, Query, ODataV4Adaptor, Predicate } from '@syncfusion/ej2-data';
import { SaveEventArgs, EditSettingsModel, FilterSettingsModel, SortSettingsModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { environment } from 'src/environments/environment';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Browser } from '@syncfusion/ej2-base';
import { Dialog } from '@syncfusion/ej2-angular-popups';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-tcpexpiry',
  templateUrl: './tcpexpiry.component.html',
  styleUrls: ['./tcpexpiry.component.scss']
})
export class TCPExpiryComponent {
  @Input() relatedTypeId: number;
  @Input() recordId: number;

  @Output() closeScopeInfo = new EventEmitter<void>();

  @ViewChild('createdOnTemplate', { static: true }) createdOnTemplate: any;
  @ViewChild('editionTmpl', { static: true }) editionTmpl: any;

  title = "TCP Expiry";
  isMobileView:boolean = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  data: DataManager;
  query: Query;
  baseUrl: string = environment.baseUrl.replace('/api/', '/odata/');
  editSettings: EditSettingsModel;
  sortSettings: SortSettingsModel;
  filterSettings: FilterSettingsModel;
  toolbar: string[];
  columns: object[];
  public pageOptions: PageSettingsModel =  { pageSize: 25, pageSizes: [25, 50, 100], pageCount: 5 };
  public submitClicked: boolean = false;
  public formData: UntypedFormGroup;
  currentUser: any;
  minDate:Date = new Date();
  editionData: Object[] = [
    { Id: 1, Name: 'Silver' },
    { Id: 2, Name: 'Gold' },
    { Id: 3, Name: 'Auditor' }
  ];
  accountData: DataManager;
  accountQuery: Query = new Query().select(['Name', 'Id']).take(10);


  constructor(private authenticationService: AuthenticationService, private formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.sortSettings = { columns: [{ field: 'CreatedOn', direction: 'Descending' }] };
    this.filterSettings = { type: "Menu" };
    this.editSettings = { allowAdding: true, mode: 'Dialog' };
    this.toolbar = ['Add']
    this.currentUser = this.authenticationService.currentUserValue;
    this.columns = [
      { field: 'Id', headerText: '', isPrimaryKey: true, visible: false },
      { field: 'Account.Name', headerText: 'Account' },
      { field: 'EditionId', headerText: 'Edition', template: this.editionTmpl },
      { field: 'SerialNo', headerText: 'Serial No' },
      { field: 'ExpiryDate', headerText: 'Expiry Date', type: 'date', format: 'dd-MMM-yyyy'},
      { field: 'Remarks', headerText: 'Remarks' },
      { field: 'CreatedOn', headerText: 'Created On', template: this.createdOnTemplate},
      { field: 'CreatedBy.FirstName', headerText: 'CreatedBy' }
    ]
    this.data = new DataManager({
      url: this.baseUrl + "TCPExpiry",
      adaptor: new ODataV4Adaptor(),
      headers: [{ 'Authorization': 'Bearer ' + this.currentUser.token }]
    });
    let predicate: Predicate = new Predicate('RelatedTypeId', 'equal', this.relatedTypeId)
      .and('RelatedId', 'equal', this.recordId);

    this.query = new Query().expand('CreatedBy, Account')
      .where(predicate);

    this.accountData = new DataManager({
      url: this.baseUrl + "Account",
      adaptor: new ODataV4Adaptor(),
      crossDomain: true,
      headers: [{ 'Authorization': 'Bearer ' + this.currentUser.token }]
    });
  }

  actionBegin(args: SaveEventArgs): void {
    let objData: any = args.rowData;
    if (args.requestType === 'beginEdit' || args.requestType === 'add') {
      this.submitClicked = false;

      this.formData = this.formBuilder.group({
        Id: [objData.Id ? objData.Id : 0],
        AccountId: [objData.AccountId, [Validators.required]],
        RelatedTypeId: [this.relatedTypeId],
        RelatedId: [this.recordId],
        EditionId: [objData.EditionId, [Validators.required]],
        SerialNo: [objData.SerialNo, [Validators.required]],
        ExpiryDate: [objData.ExpiryDate, [Validators.required]],
        Remarks: [objData.Remarks]
      });
    }
    if (args.requestType === 'save') {
      this.submitClicked = true;
      if (this.formData.valid) {
        args.data = this.formData.value;
      } else {
        args.cancel = true;
      }
    }
  }

  actionComplete(args): void {
    if(!this.isMobileView) {
    if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {

      if (args.requestType === 'add') {
        (args.form.elements.namedItem('Name') as HTMLInputElement).focus();
        args.dialog.header = 'Enter new expiry entry';
      }
    }
  }
    if (args.requestType === 'save') {
      this.submitClicked = true;
      if (this.formData.valid) {
        args.data = this.formData.value;
      } else {
        args.cancel = true;
      }
    }
  }

  public onFiltering(e, obj: string) {
    e.preventDefaultAction = true;
    var predicate = new Predicate('Name', 'contains', e.text, true);
    var query = new Query();
    //frame the query based on search string with filter type.
    query = (e.text != "") ? query.where(predicate) : query;

    //pass the filter data source, filter query to updateData method.
    switch (obj) {
      case 'a':
        e.updateData(this.accountData, query);
        break;
    }
  }

  get f() {
    return this.formData.controls;
  }

  
  close() {
    this.closeScopeInfo.emit();
  }

 

}
